import styled from "styled-components";
import { Component, useContext, useEffect, useState } from "react";
import ListSizeSetter from "../../helperComponents/ListSizeSetter";
import LoadingSection from "../../helperComponents/LoadingSection";
import CustomMasonry from "../../helperComponents/CustomMasonry";
import CustomPagination from "../../helperComponents/CustomPagination";
import { serverLine } from "../../../controllers/network/serverLine";
import CustomButton from "../../helperComponents/CustomButton";
import LoggedInBoilerplate from "../../pages/loggedIn/LoggedInBoilerplate";
import Context from "../../../Context";
import PermissionDeniedPage from "../PermissionDeniedPage";
import CustomLabel from "../CustomLabel";
import { BiExport, BiFilter, BiReset } from "react-icons/bi";
import exportFunction from "../../../controllers/customControllerForCS/exportFunction";
import MaterialInput from "../../helperComponents/MaterialInput";
import FieldsSelectorPopup from "./FieldsSelectorPopup";
import AssignmentHistoryTable from "./TableRenderForAH";
import TableRenderForAH from "./TableRenderForAH";
import CustomLabelDim from "../CustomLabelDim";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  width: 100%;
  /* margin-top: 30px; */
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const SearchContainer = styled.div`
  width: 300px;
`;

const Content = styled.div`
  /* 
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2); 
  */
  //
  //
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  min-height: 500px;
  animation: centerScaleReveal 0.4s ease-in-out forwards;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export default function TabularContentList({
  userID,
  path,
  queryParams,
  disableAllFilters,
  filters,
  title,
  nothingFoundMessage,
  supportedFields,
  initialSelectedFields,
  hideFilterField,
  readOnly,
}) {
  const { setForm } = useContext(Context);
  const [currentPage, setCurrentPage] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [entireResponse, setEntireResponse] = useState({});

  const [selectedFields, setSelectedFields] = useState(
    initialSelectedFields ? initialSelectedFields : null
  );

  useEffect(() => {
    console.log("queryParams changed", queryParams);
    setCurrentPage(0);
    doQuery(0);
  }, [itemsPerPage, queryParams]);

  if (!nothingFoundMessage) nothingFoundMessage = "cette liste est vide"; //This list is empty

  let core = null;

  if (loading) {
    core = <LoadingSection />;
  } else {
    core = (
      <TableRenderForAH
        readOnly={readOnly}
        date={queryParams.date}
        siteID={queryParams.siteID}
        shift={queryParams.shift}
        slotQuota={entireResponse?.slotQuota}
        slotTargets={entireResponse?.slotTargets}
        vacantSlotAssignments={entireResponse?.vacantSlotAssignments}
        refresh={() => {
          setCurrentPage(0);
          doQuery(0);
        }}
        items={items}
        setItems={setItems}
        fields={selectedFields}
      ></TableRenderForAH>
    );

    if (!items.length) {
      core = <CustomLabelDim>{nothingFoundMessage}</CustomLabelDim>;
    }
  }

  let filterComp = (
    <Filters>
      {filters}

      {hideFilterField ? null : (
        <CustomButton
          onClick={openFieldSelector}
          style={{ borderRadius: "10px" }}
          icon={<BiFilter />}
        >
          Filter Fields
        </CustomButton>
      )}

      {/* <CustomButton
        onClick={doExport}
        style={{ borderRadius: "10px" }}
        icon={<BiExport />}
      >
        Export
      </CustomButton> */}
    </Filters>
  );

  if (disableAllFilters) filterComp = null;

  return (
    <Container>
      {title ? <CustomLabel>{title}</CustomLabel> : null}

      {filterComp}

      <Content>{core}</Content>

      {loading ? null : (
        <BottomPart>
          <ListSizeSetter value={itemsPerPage} onChange={setItemsPerPage} />
          <CustomPagination
            value={currentPage}
            max={maxPages}
            onChange={doQuery}
          />
        </BottomPart>
      )}
    </Container>
  );

  function openFieldSelector() {
    setForm({
      title: "Sélectionner",
      component: (
        <FieldsSelectorPopup
          fieldsList={supportedFields}
          value={selectedFields}
          onChange={setSelectedFields}
        />
      ),
    });
  }

  function doExport() {
    exportFunction({
      title: "Export",
      selectedFields: selectedFields,
      path: getThePath(currentPage) + "&forExport=true",
    })();
  }

  function getThePath(newPage) {
    // if (!newPage) newPage = currentPage; this was causing a bug when newPage was 0

    let more = "";

    let theParams = { ...queryParams };

    if (userID) theParams.userID = userID;

    for (let key in theParams) {
      if (theParams[key]) {
        more = more + `&${key}=${theParams[key]}`;
      }
    }

    return `/${path}/?currentPage=${newPage}&itemsPerPage=${itemsPerPage}${more}&makeFieldsReadable=true&showImage=true&allowID=true`;
  }

  function doQuery(newPage) {
    if (!queryParams.date) {
      setLoading(false);
      return;
    }

    setCurrentPage(newPage);
    let thePath = getThePath(newPage);

    let more = "";
    for (let key in queryParams) {
      if (queryParams[key]) {
        more = more + `&${key}=${queryParams[key]}`;
      }
    }

    setLoading(true);

    serverLine.get(thePath).then((newData) => {
      setLoading(false);
      setEntireResponse(newData);
      setItems(newData.list);
      setMaxPages(newData.maxPages);
    });
  }
}
